import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef } from 'react';
import invariant from 'invariant';
import isEqual from 'lodash/isEqual';
import { useSelector } from 'react-redux';
import { Button, Label, Modal } from '@cancercentrum/rcc-bootstrap';
import { useI18n } from '../../i18n';
import isNotValidationGroupError from '../../utils/isNotValidationGroupError';
const DetailedWarningsModal = (props)=>{
    const { t } = useI18n();
    const rowRef = useRef(undefined);
    const propsRef = useRef(undefined);
    const { row } = useSelector((state)=>{
        if (process.env.NODE_ENV !== 'production') {
            invariant(state.data, `data is missing in the redux store. Make sure you have created the initial data state and are using the dataReducer, e.g.

import { configureStore } from '@reduxjs/toolkit';
import { dataReducer, settingsReducer, dataUtils } from '@cancercentrum/rcc-react';

const dataState = dataUtils.createDataState();
const store = configureStore({
    reducer:
        data: dataReducer,
        settings: settingsReducer,
    },
    preloadedState: { data: dataState },
});
`);
        }
        return {
            row: state.data.present,
            history: state.data.past,
            future: state.data.future
        };
    }, isEqual);
    propsRef.current = props;
    rowRef.current = row;
    const { validationPredicate, showModal, closeModal } = propsRef.current;
    const curErrors = rowRef.current.getErrors({
        includePristine: true,
        validationPredicate: validationPredicate
    });
    const handleSaveClick = ()=>{
        closeModal(true);
    };
    const handleCloseCancelClick = ()=>{
        closeModal(false);
    };
    const warningsCount = curErrors.filter((x)=>x.$errors.some((y)=>y.isWarning) || x.$errors.some((y)=>y.name && y.isFatal === false)).length;
    const warningsArray = curErrors.map((err)=>{
        const warnings = err.$errors.filter((x)=>x.isFatal === false);
        if (isNotValidationGroupError(err)) {
            const label = err.$rcc.regvarMetadata.label;
            const warningMessages = warnings.map((x)=>({
                    message: t(x.message)
                })).toJS();
            return warningMessages.map((x, key)=>/*#__PURE__*/ _jsxs("li", {
                    children: [
                        /*#__PURE__*/ _jsx("label", {
                            className: "review-warning",
                            children: label
                        }),
                        ' ',
                        x.message
                    ]
                }, key));
        } else {
            if (warnings.length > 0) {
                return warnings.map((warning, key)=>{
                    return /*#__PURE__*/ _jsxs("li", {
                        children: [
                            /*#__PURE__*/ _jsx("label", {
                                className: "review-warning",
                                children: warning.name
                            }),
                            ' ',
                            warning.message
                        ]
                    }, key);
                });
            }
        }
    });
    return /*#__PURE__*/ _jsx("div", {
        id: "detailed-warnings-modal",
        children: /*#__PURE__*/ _jsxs(Modal, {
            show: showModal,
            onHide: handleCloseCancelClick,
            children: [
                /*#__PURE__*/ _jsx(Modal.Header, {
                    closeButton: true
                }),
                /*#__PURE__*/ _jsx(Modal.Body, {
                    children: warningsArray.length > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                children: /*#__PURE__*/ _jsxs(Label, {
                                    className: "review-label",
                                    bsStyle: "warning",
                                    children: [
                                        t('component.reviewform.warningsCount'),
                                        ' ',
                                        warningsCount
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(_Fragment, {
                                children: /*#__PURE__*/ _jsx("ul", {
                                    className: "review-list",
                                    children: warningsArray.map((warning)=>warning)
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs(Modal.Footer, {
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            onClick: handleCloseCancelClick,
                            children: t('button.close')
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            onClick: handleSaveClick,
                            children: t('Spara ändå')
                        })
                    ]
                })
            ]
        })
    });
};
export default DetailedWarningsModal;
